import { BookmarksPageType } from 'components/saved-items/SavedItems';

const SavedItemsHelpers = {
    urls: {
        overview: (type?: BookmarksPageType) => `/bookmarks${type ? `/${type}` : ''}`,
    },
} as const;

export { SavedItemsHelpers };
